import { useState } from 'react';
import loadable from '@loadable/component';
import { useTracking } from 'react-tracking';

import type { ComponentPropsWithoutRef } from 'react';

import { Button } from '@simplywallst/ui-core/next';

const AddTransaction = loadable(() => import('../AddTransaction'), {
  resolveComponent: (c) => c.AddTransaction,
});

type Props = ComponentPropsWithoutRef<typeof Button> & {
  portfolioId: string;
};

export const AddTransactionButton = ({
  children,
  portfolioId,
  ...rest
}: Props) => {
  const { trackEvent } = useTracking({
    modifier: 'addTransaction',
    portfolioId,
  });
  const [showAddTransaction, setShowAddTransaction] = useState(false);
  return (
    <>
      <Button
        {...rest}
        onClick={() => {
          trackEvent({ action: 'click' });
          setShowAddTransaction(true);
        }}
      >
        {children}
      </Button>
      {showAddTransaction && (
        <AddTransaction
          portfolioId={portfolioId}
          onClose={() => setShowAddTransaction(false)}
        />
      )}
    </>
  );
};
